import React from 'react';
import { useTheme } from 'styled-components';

export const SendSvg = (props) => {
  const { width, height, color, vertical } = props;

  const theme = useTheme();

  if (vertical) {
    return (
      <svg width={width ?? "14"} height={height ?? "15"} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5043 2.18942C12.2125 1.88995 11.7807 1.77838 11.378 1.89582L1.98832 4.62632C1.56348 4.74435 1.26236 5.08316 1.18124 5.51359C1.09838 5.95164 1.38783 6.50772 1.76598 6.74026L4.70193 8.54474C5.00306 8.72971 5.39172 8.68332 5.6409 8.43199L9.00286 5.04911C9.1721 4.87294 9.45221 4.87294 9.62145 5.04911C9.79068 5.2194 9.79068 5.49538 9.62145 5.67154L6.25365 9.05502C6.00388 9.30575 5.9572 9.69624 6.14102 9.99924L7.93493 12.9646C8.14501 13.3169 8.50683 13.5166 8.90366 13.5166C8.95034 13.5166 9.00286 13.5166 9.04955 13.5107C9.50473 13.452 9.86655 13.1408 10.0008 12.7004L12.7844 3.32272C12.907 2.92343 12.7961 2.48889 12.5043 2.18942Z" fill={color ?? "#9EACB0"} />
      </svg>
    )
  }

  return (
    <svg width={width ?? '20'} height={height ?? '21'} fill={color ?? theme?.colour?.primary ?? '#1DBD6B'} viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.2724 11.1044C19.296 10.388 18.9209 9.72176 18.2974 9.36357L3.76864 1.00144C3.11809 0.616536 2.34161 0.646824 1.71325 1.05786C1.07338 1.47579 0.729896 2.49412 0.89169 3.23774L2.14893 9.0101C2.27801 9.60201 2.79703 10.0273 3.40367 10.0367L11.5785 10.1736C11.9973 10.1736 12.3301 10.5198 12.3134 10.9382C12.3039 11.3497 11.9628 11.6775 11.544 11.6776L3.36149 11.5342C2.75488 11.5233 2.21677 11.9295 2.06063 12.5166L0.526363 18.2564C0.340449 18.9346 0.523479 19.619 0.994867 20.1094C1.05032 20.1671 1.11271 20.2321 1.17543 20.2828C1.78872 20.7757 2.60318 20.8532 3.30696 20.4959L18.2044 12.7969C18.8435 12.474 19.2489 11.8208 19.2724 11.1044Z" />
    </svg>
  )
}


